<template>
  <div class="rawControls" v-loading="rawControls.loading">
    <div class="search">
      <el-input
        v-model="searchText"
        size="small"
        prefix-icon="el-icon-search"
        placeholder="请输入"
        clearable
        style="margin-bottom: 10px"
      ></el-input>
    </div>
    <section v-for="(group, index) in searchRawControls" :key="index" class="group">
      <div class="title" v-if="group.options.length > 0">{{ group.name }}</div>
      <draggable
        :group="{ name: 'control', pull: 'clone', put: false }"
        :list="group.options"
        :clone="cloneControl"
        :sort="false"
        :disabled="draggableDisabled"
        handle=".item"
        class="list"
      >
        <div v-for="(item, index) in group.options" :key="index" class="field-box">
          <template v-if="item._type != 'fieldsGroup'">
            <div class="item" v-if="item._type !== 'select2' && item._type !== 'table'">
              <svg-icon
                :icon-class="'control_' + item._type"
                style="margin: 0 4px"
                class="icon"
              ></svg-icon>
              {{ item.name }}
            </div>
          </template>
          <template v-else>
            <draggable
              :group="{ name: 'fields-group', pull: 'clone', put: false }"
              :list="groupControl"
              :clone="cloneGroup"
              :sort="false"
              handle=".groupControl"
            >
              <div class="fields-group groupControl">
                <svg-icon
                  :icon-class="'control_' + item._type"
                  style="margin: 0 4px"
                  class="icon"
                ></svg-icon>
                {{ item.name }}
              </div>
            </draggable>
          </template>
        </div>
      </draggable>
    </section>
  </div>
</template>

<script>
import { groupControl } from "./static"
import draggable from "vuedraggable"
import { deepClone, randomString } from "@/utils/common"
import { getObjectId } from "@/api/sheet/sheet"

let globalId = 0
export default {
  name: "rawControls",
  components: {
    draggable
  },
  props: {
    rawControls: Object
  },
  data() {
    return {
      draggableDisabled: false,
      groupControl,
      searchText: ""
    }
  },
  computed: {
    searchRawControls() {
      let searchRawControls = this.rawControls.data
      searchRawControls = searchRawControls.map(group => {
        let groupInfo = deepClone(group)
        groupInfo.name = group.name
        groupInfo.options = group.options.filter(item => item.name.includes(this.searchText))
        return groupInfo
      })
      return searchRawControls
    }
  },
  methods: {
    // 复制原始配置项，新增表格字段
    cloneControl(obj) {
      let control = this._.cloneDeep(obj)
      this.draggableDisabled = true
      getObjectId().then(res => {
        obj._cid = res
        this.draggableDisabled = false
      })
      control = this.setDefaultInfo(control)
      control._isNew = true // 新添加的
      return control
    },
    // 设置 control 的一些默认信息
    setDefaultInfo(control) {
      globalId++
      control.name += globalId
      control.code = String(globalId)
      // delete control._cid
      switch (control._type) {
        case "ref":
          control.oneFlag = true
          break
        case "select2":
          control.url = ""
          break
        case "calc":
          control.var1 = null
          control.var2 = null
          control.disabled = true
          break
        case "sn":
        case "remark":
        case "field":
        case "gather":
          control.disabled = true
          break
        case "option":
          control.options.forEach(option => delete option.color)
          control.defaultVal = []
          break
        case "time":
          control.timeScope = { weekLimit: null, timeRange: null }
          break
        case "file":
          control.displayType = "list"
          break
      }
      return control
    },
    // 新增表格分组
    cloneGroup(obj) {
      obj.data.id = randomString(10)
      return this._.cloneDeep(obj.data)
    }
  }
}
</script>

<style lang="scss" scoped>
.rawControls {
  box-sizing: border-box;
  padding: 26px 20px;
  background-color: #f1f2f3;
  user-select: none;
  .group {
    font-size: 13px;
    box-sizing: border-box;
    .title {
      font-weight: bold;
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      margin: 12px 0;
      justify-content: space-between;
      .item,
      .groupControl {
        width: 124px;
        box-sizing: border-box;
        line-height: 36px;
        margin-bottom: 12px;
        padding-left: 12px;
        list-style: none;
        position: relative;
        background-color: #fff;
        border: 1px solid transparent;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.16);
        border-radius: 4px;
        cursor: grab;
        .icon {
          color: #606266;
        }
        &:hover {
          border-color: #2196f3;
          color: #2196f3;
          .icon {
            color: #2196f3;
          }
        }
      }
    }
  }
}
</style>
